module.exports = __webpack_public_path__ + "img/no_image_available.24e17c33.png";